import { render, staticRenderFns } from "./RawMaterialShow.vue?vue&type=template&id=bc608dea&"
import script from "./RawMaterialShow.vue?vue&type=script&lang=js&"
export * from "./RawMaterialShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports